import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!sid) { setErr("Missing session id"); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status === "paid" || attempts > 20) return;
        attempts += 1;
        setTimeout(poll, 2000);
      } catch { if (!cancelled) setTimeout(poll, 2500); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  const paid = status.payment_status === "paid";

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      {paid ? (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-brand" />
          <h1 className="mt-6 font-display font-black text-5xl tracking-tighter">Payment received.</h1>
          <p className="mt-4 text-[#475569]">Thanks for your business. A receipt has been emailed to you.</p>
        </>
      ) : err ? (
        <>
          <XCircle className="w-16 h-16 mx-auto text-red-400" />
          <h1 className="mt-6 font-display font-black text-4xl">{err}</h1>
        </>
      ) : (
        <>
          <Loader2 className="w-14 h-14 mx-auto text-brand animate-spin" />
          <h1 className="mt-6 font-display font-black text-4xl">Confirming payment…</h1>
          <p className="mt-4 text-[#475569] text-sm">Hold on — this only takes a second.</p>
        </>
      )}
      <div className="mt-12"><Link to="/" className="btn-outline">Back home</Link></div>
    </div>
  );
}
